import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const name = 'pageSections';

interface IPageSectionsState {
  collapsed: { [id: string]: boolean };
}

const initialState: IPageSectionsState = { collapsed: {} };

export const { reducer, actions } = createSlice({
  name,
  initialState,
  reducers: {
    addPageSectionId: (state, action: PayloadAction<string>) => {
      state.collapsed[action.payload] = false;
    },
    deletePageSectionId: (state, action: PayloadAction<string>) => {
      delete state.collapsed[action.payload];
    },
    setCollapsed: (state, action: PayloadAction<{ id: string; collapsed: boolean }>) => {
      if (action.payload.id.trim() === '') return;
      state.collapsed[action.payload.id] = action.payload.collapsed;
    },
    setAllCollapsed: (state, action: PayloadAction<boolean>) => {
      Object.keys(state.collapsed).forEach((id) => (state.collapsed[id] = action.payload));
    },
  },
});
